module.exports = __webpack_public_path__ + "static/media/email.6e25e6df.png";